<template>

  <v-container class="pa-0">

    <v-row>
      <v-col class="pa-0">

        <imagelist></imagelist>

      </v-col>
    </v-row>
  </v-container>

</template>


<script>
  import ImageList from './ImageList.vue'

  export default {
    data: () => ({
      dialog: false
    }),

    computed: {

    },

    methods: {
     
    },
    components: {
      imagelist: ImageList,
    }
  }
</script>


<style scoped>

</style>
